<template>
  <b-row>
    <b-col md="12">
      <b-card title="ارسال مطلب">
        <b-row>
          <b-col md="7" sm="12">
            <b-form-group label="عنوان">
              <b-input v-model="article.title"></b-input>
            </b-form-group>
          </b-col>

          <b-col md="2" sm="12">
            <b-form-group label="زبان مطلب">
              <b-select v-model="article.lang">
                <option
                  v-for="(langitem, index) in lang"
                  v-bind:key="index"
                  :value="langitem.id"
                  >{{ langitem.title }} [ {{ langitem.slug }} ]</option
                >
              </b-select>
            </b-form-group>
          </b-col>

          <b-col md="3" sm="12">
            <b-form-group label="موضوع">
              <b-select v-model="article.cat">
                <option
                  v-for="(catitem, index) in cats"
                  v-bind:key="index"
                  :value="catitem.id"
                  ><b v-if="catitem.parentid != 0">{{ catitem.parent }} =></b>
                  {{ catitem.label }} [ {{ catitem.lang }} ]</option
                >
              </b-select>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <quillEditor v-model="article.text" />
          </b-col>

          <b-col md="12">
            <b-form-group label="برچسب">
              <InputTag v-model="article.tags" :add-tag-on-blur="true" />
            </b-form-group>
          </b-col>
        </b-row>
 
                <b-row class="flex-row-reverse">
      
         <div  class="right" >
        <b-button variant="info" @click="save">ارسال</b-button>
      
      </div>

        <div class="right  mr-2" >
            <b-form-group>
              <b-select v-model="article.status">
                <option
                  v-for="(statusitem, index) in status"
                  v-bind:key="index"
                  :value="statusitem.value"
                >
                  {{ statusitem.name }}
                </option>
              </b-select>
            </b-form-group>
         </div>
      </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import ApiService from "@/core/services/api.service";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import InputTag from "vue-input-tag";
export default {
  name: "import",
  components: {
    quillEditor,
    InputTag
  },
  data() {
    return {
      file: "",
      name: "",
      myHTML: "",
      lang: [],
            status: [
        {
          name : 'انتشار',
          value : 0,
        },
         {
          name : 'پیش نویس',
          value : 1,
        },
         {
          name : 'ارجاع',
          value : 2,
        },
         {
          name : 'سایر',
          value : 3,
        }
      ],
      cats: [],
      works: [],
      tags: [],
      article: {
        lang: "",
        cat: "",
        title: "",
        status: 0,
        text: "",
        tags: ""
      }
    };
  },
  created() {
    this.getall();
  },
  methods: {
    getall: function() {
      ApiService.get("admin/taxnomy#", {})
        .then(({ data }) => {
          this.cats = data;
        })
        .catch(({ response }) => {});

      ApiService.get("admin/langlist#", {})
        .then(({ data }) => {
          this.lang = data;
        })
        .catch(({ response }) => {});
    },

    save: function() {
      ApiService.post("admin/article", {
        article: this.article
      })
        .then(({ data }) => {
          this.$vs.notification({
            progress: "auto",
            color: "success",
            position: "bottom-left",
            text: "مطلب با موفقیت ذخیره شد"
          });

          this.$router.push({ path: "/article/mng" });
        })
        .catch(({ response }) => {
          this.$vs.notification({
              progress: "auto",
              color: "danger",
              position: "bottom-left",
              text: "ذخیره ویدئو با خطا مواجه گردید"
            });
        });
    }
  }
};
</script>
